module.exports = __webpack_public_path__ + "img/auddia.28b73f96.svg";